import React, { useState } from 'react'
import { Box, Button, TextField } from '@material-ui/core'
import { Controller, useForm } from 'react-hook-form'

import useSnackbar from 'hooks/useSnackbar'
import useClientPortalTheme from 'hooks/useClientPortalTheme'

import schema from './schema'
import useStyles from './styles'
import * as service from 'service'
import helpers from 'helpers'

const LoginSSOForm = () => {
  const [loading, setLoading] = useState(false)

  const { clientPortalTheme } = useClientPortalTheme()
  const classes = useStyles({ clientPortalTheme })()

  const snackbar = useSnackbar()

  const { handleSubmit, errors, control } = useForm({
    validationSchema: schema,
    defaultValues: {
      email: '',
    },
  })

  const onSubmit = async (data) => {
    try {
      setLoading(true)
      const response = await service.dponet.ssoCorporateGroups.redirect({
        email: data.email,
      })
      const redirectUrl = response?.data?.redirectUrl

      if (redirectUrl) {
        sessionStorage.setItem('currentEmailSamlLogin', data.email)
        return (window.location.href = redirectUrl)
      }

      snackbar.open({
        message:
          'Não foi possível fazer o login, a URL de redirecionamento não foi encontrada.',
        variant: 'error',
      })
    } catch (error) {
      console.error(error)
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error, false) ||
          error?.error?.message,
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Controller
        as={
          <TextField
            label="Email"
            type="email"
            color="primary"
            variant="outlined"
            error={!!errors.email}
            helperText={errors?.email?.message}
            fullWidth
          />
        }
        control={control}
        name="email"
        mode="onBlur"
      />
      <Box mt={3}>
        <Button
          type="submit"
          variant="contained"
          size="large"
          fullWidth
          className={classes.buttonPrimary}
          disabled={loading}
        >
          {loading ? 'Carregando...' : 'Acessar'}
        </Button>
      </Box>
    </form>
  )
}

export default LoginSSOForm
